exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--position-percent:50%}._2qIta{top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;z-index:var(--z-index-high)}._2qIta,._2qIta:before{position:absolute;width:100%;height:100%}._2qIta:before{content:\"\";background-color:rgba(0,0,0,.3)}.BYB_5{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;z-index:var(--z-index-high)}.BYB_5,.BYB_5:before{position:fixed;top:0;left:0}", ""]);

// exports
exports.locals = {
	"wrapper": "_2qIta",
	"wrapperFullPage": "BYB_5"
};